<mat-card [@snFadeInDown] *ngIf="translationsLoaded">
  <form [formGroup]="form" (ngSubmit)="onFormSubmit()">
    <sn-brand-logo
      type="horizontal"
      class="brand-logo__display-block brand-logo__margin-vertical-md brand-logo__text-center"
    ></sn-brand-logo>

    <sn-alert dense class="auth-reset-confirm-rounded-0" type="danger" *ngIf="form.errors">
      <div *ngFor="let error of form.errors | keyvalue">
        <b>{{ toStartCase(error.key) }}</b>:
        <ul class="auth-reset-confirm-mb-0">
          <li *ngFor="let item of error.value">{{ item }}</li>
        </ul>
      </div>
    </sn-alert>

    <!-- TO-DO: Translate rules strings coming from BE -->
    <main class="auth-reset-confirm-p-sm" *ngIf="form">
      <h3 class="auth-reset-confirm-text-center">{{ 'account.dialogs.changePassword.resetConfirm.resetYourPassword' | t }}</h3>
      <ul class="text-secondary" *ngIf="rules">
        <li *ngFor="let rule of rules">  
          {{ rule }}  
        </li>
      </ul>
      <ul class="text-secondary" 
      *ngIf="!rules">
      <li>Must be at least 8 characters long.</li>
      <li>Must be alphanumeric.</li>
      <li>Must not be similar to user email or name.</li>
      <li>Must not be a common word.</li>
      </ul>
      <sn-reset-confirm-form [form]="form" [formModel]="formModel" [phoneConfirmationRequired]="phoneConfirmationRequired"></sn-reset-confirm-form>
    </main>

    <mat-card-actions>
      <sn-flat-button
        type="submit"
        color="accent"
        class="auth-reset-confirm-w-100"
        [isLoading]="isLoading"
        [disabled]="form.invalid"
      >
        {{ 'account.dialogs.changePassword.resetConfirm.resetPassword' | t }}
      </sn-flat-button>
    </mat-card-actions>
  </form>
</mat-card>
